import { AnalyticsUserActionEventObjectException } from '../errors/analytics-error';
import Logger from '../utils/analytics-logger';
import DataObject from './data-object';

export default class UserActionEventObject extends DataObject {
  constructor(data) {
    super('uaevent', data);

    if (!data.category) {
      Logger.error(
        "[AnalyticsUserActionEventObjectException] Category is required for uaevent (L'Oréal guideline)",
        data,
      );
      throw new AnalyticsUserActionEventObjectException(
        "Category is required for uaevent (L'Oréal guideline)",
      );
    }

    if (!data.action) {
      Logger.error(
        "[AnalyticsUserActionEventObjectException] Action is required for uaevent (L'Oréal guideline)",
        data,
      );
      throw new AnalyticsUserActionEventObjectException(
        "Action is required for uaevent (L'Oréal guideline)",
      );
    }

    if (!data.label) {
      Logger.error(
        "[AnalyticsUserActionEventObjectException] Label is required for uaevent (L'Oréal guideline)",
        data,
      );
      throw new AnalyticsUserActionEventObjectException(
        "Label is required for uaevent (L'Oréal guideline)",
      );
    }

    this.result.ecommerce = 'undefined';
  }

  set category(category) {
    this.result.eventCategory = this.setProperty(category);
  }

  get category() {
    return this.result.eventCategory;
  }

  set action(action) {
    this.result.eventAction = this.setProperty(action);
  }

  get action() {
    return this.result.eventAction;
  }

  set label(label) {
    this.result.eventLabel = this.setProperty(label);
  }

  get label() {
    return this.result.eventLabel;
  }

  set event_name(eventname) {
    this.result.event_name = this.setProperty(eventname);
  }

  get event_name() {
    return this.result.event_name;
  }

  set prop_event_name(e) {
    this.result.event_name = this.setProperty(e);
  }

  get prop_event_name() {
    return this.result.event_name;
  }

  set prop_module_name(e) {
    this.result.module_name = this.setProperty(e);
  }

  get prop_module_name() {
    return this.result.module_name;
  }
  set prop_cta_name(e) {
    this.result.cta_name = this.setProperty(e);
  }

  get prop_cta_name() {
    return this.result.cta_name;
  }
  set prop_link_url(e) {
    this.result.link_url = this.setProperty(e);
  }

  get prop_link_url() {
    return this.result.link_url;
  }

  get social_network() {
    return this.result.social_network;
  }
  set social_network(e) {
    this.result.social_network = this.setProperty(e);
  }

  get social_action() {
    return this.result.social_action;
  }
  set social_action(e) {
    this.result.social_action = this.setProperty(e);
  }

  set search_keyword(e) {
    this.result.search_keyword = this.setProperty(e);
  }

  get search_keyword() {
    return this.result.search_keyword;
  }

  set method(e) {
    this.result.method = this.setProperty(e);
  }

  get method() {
    return this.result.method;
  }

  set cta_name(e) {
    this.result.cta_name = this.setProperty(e);
  }

  get cta_name() {
    return this.result.cta_name;
  }

  set link_url(e) {
    this.result.link_url = this.setProperty(e);
  }

  get link_url() {
    return this.result.link_url;
  }

  set click_area(e) {
    this.result.click_area = this.setProperty(e);
  }

  get click_area() {
    return this.result.click_area;
  }

  set breadcrumb(e) {
    this.result.breadcrumb = this.setProperty(e);
  }

  get breadcrumb() {
    return this.result.breadcrumb;
  }

  set article_name(e) {
    this.result.article_name = this.setProperty(e);
  }

  get article_name() {
    return this.result.article_name;
  }

  set file_type(e) {
    this.result.file_type = this.setProperty(e);
  }

  get file_type() {
    return this.result.file_type;
  }

  set file_name(e) {
    this.result.file_name = this.setProperty(e);
  }

  get file_name() {
    return this.result.file_name;
  }

  set module_name(e) {
    this.result.module_name = this.setProperty(e);
  }

  get module_name() {
    return this.result.module_name;
  }

  set video_title(e) {
    this.result.video_title = this.setProperty(e);
  }

  get video_title() {
    return this.result.video_title;
  }

  set video_action(e) {
    this.result.video_action = this.setProperty(e);
  }

  get video_action() {
    return this.result.video_action;
  }

  set filter_type(e) {
    this.result.filter_type = this.setProperty(e);
  }

  get filter_type() {
    return this.result.filter_type;
  }

  set filter_value(e) {
    this.result.filter_value = this.setProperty(e);
  }

  get filter_value() {
    return this.result.filter_value;
  }

  set value(value) {
    this.result.eventValue = this.setProperty(value);
  }
}
